import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { sectionsApi } from '../../services/apiV2';

export const V2DashboardRedirect: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      try {
        await sectionsApi.list();
      } finally {
        navigate(user?.role === 'teacher' ? '/v2/teacher' : '/v2/student', { replace: true });
      }
    };
    redirect();
  }, [navigate, user]);

  return <Navigate to={user?.role === 'teacher' ? '/v2/teacher' : '/v2/student'} replace />;
};
